import ReactGA from "react-ga4";

const MEASUREMENT_ID = "G-TY14F4ESF4";

export const initGA = () => {
  ReactGA.initialize(MEASUREMENT_ID);
  ReactGA.gtag("config", MEASUREMENT_ID, {
    send_page_view: false
  });
};

export const normalizeUrl = (rawUrl) => {
  let [beforeQuery, afterQuery] = rawUrl.split("?");
  let path = beforeQuery;
  let utmParams = "";
  if (beforeQuery.includes("&utm_")) {
    const parts = beforeQuery.split("&");
    path = parts.shift(); // first part = clean path
    utmParams = parts.join("&"); // rest = utm params
  }
  // Merge all params
  const finalParams = [utmParams, afterQuery]
    .filter(Boolean)
    .join("&");
  return finalParams ? `${path}?${finalParams}` : path;
};

export const sendPageView = (username,title,utm_source) => {
    let fixedUrl = normalizeUrl(window.location.href);
    //console.log("fixedUrl:"+fixedUrl);
    ReactGA.event("virtual_page_view", {
      page_location: fixedUrl,
      page_title: title
    });
    ReactGA.event("author_click", {
      page_location: fixedUrl,
      page_title: title,
      author_name: username
    });
    ReactGA.event("virtual_utm_source", {
      page_location: fixedUrl,
      page_title: title,
      utm_source: utm_source
    });
};
